export default __webpack_public_path__ + "static/media/l4-p5.189ba06a.svg";